import React from 'react';

import utilsService from '../../services/utilsService';

import VIDABOO_CONSTANTS from '../../config/consts';
import userDefaultImage from '../../assets/svg/user-default-icon.svg';

import './personalPageMentorInfo.css';

const PersonalPageMentorInfo = ({
  extendedMentorDto = {},
  selectedWidgetAppType = null,
}) => {
  return (
    <div
      className={`et-v2-personal-page-mentor-info-container ${selectedWidgetAppType === VIDABOO_CONSTANTS.WIDGET_APP_TYPES.NONE ? 'et-v2-ppmi-centered-wrap' : selectedWidgetAppType === VIDABOO_CONSTANTS.WIDGET_APP_TYPES.SCHEDULE_MEETING ? 'et-v2-ppmi-schedule' : ''}`}>
      <img
        className="et-v2-ppmi-mentor-img"
        src={
          extendedMentorDto.photoDto?.photoUrl
            ? utilsService.getPhotoManipulatedUrl(
                extendedMentorDto?.photoDto,
                VIDABOO_CONSTANTS.CLOUDINARY_IMAGE_MANIPULATIONS
                  .WIDGET_MASK_IMAGE,
              )
            : userDefaultImage
        }
        alt="mentorImg"
      />
      <div className="et-v2-ppmi-name-title-wrap">
        <div className="et-v2-ppmi-display-name">
          {extendedMentorDto.mentorDto.displayName}
        </div>
        <div className="et-v2-ppmi-session-title">
          {extendedMentorDto.sessionTemplateDto?.sessionTitle}
        </div>
      </div>
    </div>
  );
};

export default PersonalPageMentorInfo;
